export enum CreditNoteStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  VOIDED = 'VOIDED'
}
